import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ALL_PATIENT_CHALLENGES_BY_ID_KEY } from '_api/queries/challenge/useGetAllPatientChallengesByID';
import { AddChallengeToPatientPayload, CompletedDatePayload } from '_api/types';

export const SET_CHALLENGE_COMPLETED_DATE = 'set-challenge-completed-date';

export const useCompletePatientChallenge = () => {
  const queryClient = useQueryClient();
  return useApiMutation<AddChallengeToPatientPayload, CompletedDatePayload>(
    ({ patientContentId }) =>
      `/challenge/set-challenge-completed-date/${patientContentId}`,
    'put',
    {},
    {
      mutationKey: [SET_CHALLENGE_COMPLETED_DATE],
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_ALL_PATIENT_CHALLENGES_BY_ID_KEY],
        });
      },
    },
  );
};
